export default "__VITE_ASSET__DTb7ArDb__"